/**
 * Ziyaret detay drawer'ı — ZIYARET_TAKIP.md §5.2 son madde.
 *
 * Müşteri künyesi + giriş/çıkış mini haritası + KATMAN 3 hareket timeline'ı.
 * Sağdan açılır; `.drawer`/`.scrim` sfa.css'ten gelir.
 */

import {
  activityTarget, activityTargetLabel, fmtDuration, fmtMoney, fmtNum, fmtTime,
  OUTCOME_LABELS, OUTCOME_PILL, PAYMENT_LABELS,
} from './shared';
import { IcClose, IcLogin, IcLogout, IcPin, IcStore } from './icons';

export function VisitDrawer({ open, detail, loading, onClose, onOpenDocument }) {
  const v = detail?.visit;
  const activities = detail?.activities || [];

  return (
    <>
      <div className={`scrim ${open ? 'on' : ''}`} onClick={onClose} />
      <aside className={`drawer ${open ? 'on' : ''}`}>
        {/* #793 Başlık = "KOD - ÜNVAN", tek satır ve BELİRGİN. Eskiden ünvan tek başına başlıktı;
            uzun ticari ünvanlarda satır taşıyor, kod ise altta soluk yazıda kayboluyordu — talep
            künyenin ilk bakışta "hangi müşteri" sorusunu cevaplaması. Rut bilgisi alt satırda kalır. */}
        <div className="dh">
          <div className="ico"><IcPin size={18} /></div>
          <div>
            <b style={{ fontSize: 15, fontWeight: 800, letterSpacing: '-.01em' }}>
              {[v?.customerCode, v?.customerTitle].filter(Boolean).join(' - ') || 'Ziyaret'}
            </b>
            <span>
              {v?.isInRoute === true && 'Rut İçi'}
              {v?.isInRoute === false && 'Rut Dışı'}
              {v?.isInRoute == null && '—'}
            </span>
          </div>
          <button type="button" className="x" onClick={onClose} aria-label="Kapat">
            <IcClose size={18} />
          </button>
        </div>

        <div className="db">
          {loading && <div style={{ padding: 20 }}>Yükleniyor…</div>}

          {!loading && v && (
            <>
              <div className="dsec">Ziyaret Künyesi</div>
              {/* #793 (2. tur) KOD - ÜNVAN, "Ziyaret Künyesi" başlığının HEMEN ALTINDA.
                  Drawer'ın en üstündeki başlıkta da duruyor ama talep bilginin künyenin ilk satırı
                  olmasıydı ("künye başlığının hemen altına, BOLD karakterlerle"); üstteki başlık
                  scroll'la birlikte gözden kaçıyordu. Kod veya ünvan gelmezse satır hiç çizilmez —
                  boş bir başlık, bilgi yokluğunu gizlemekten iyidir. */}
              {(v.customerCode || v.customerTitle) && (
                <div style={{
                  padding: '10px 20px 2px', fontFamily: 'var(--fd)', fontSize: 15, fontWeight: 800,
                  letterSpacing: '-.01em', color: 'var(--strong)', lineHeight: 1.4,
                }}>
                  {[v.customerCode, v.customerTitle].filter(Boolean).join(' - ')}
                </div>
              )}
              <div className="kv">
                <span className="k">Giriş — Çıkış</span>
                <span className="v">{fmtTime(v.startedAt, true)} — {fmtTime(v.endedAt, true)}</span>
                <span className="k">Süre</span>
                <span className="v">{fmtDuration(v.durationSec)}</span>
                <span className="k">Sonuç</span>
                <span className="v">
                  {v.outcome
                    ? <span className={`pill ${OUTCOME_PILL[v.outcome] || 'gr'}`}>
                      {OUTCOME_LABELS[v.outcome] || v.outcome}
                    </span>
                    : '—'}
                </span>
                {v.nonSaleNote && (<>
                  <span className="k">Satmama Notu</span><span className="v">{v.nonSaleNote}</span>
                </>)}
                <span className="k">Gün içi sıra</span>
                <span className="v">{v.sequenceNo ?? '—'}</span>
                <span className="k">Plan sapma</span>
                <span className="v">
                  {v.timeViolationMin != null
                    ? `${v.timeViolationMin > 0 ? '+' : ''}${v.timeViolationMin} dk ${v.isTimeViolation ? '(tolerans dışı)' : '(tolerans içi)'}`
                    : 'plan saati yok'}
                </span>
                <span className="k">Hareket sayısı</span>
                <span className="v">{fmtNum(v.activityCount)}</span>
                <span className="k">Belge özeti</span>
                <span className="v">
                  {fmtNum(v.orderCount)} sipariş · {fmtMoney(v.orderAmount)} ₺
                  {v.invoiceCount > 0 && ` · ${fmtNum(v.invoiceCount)} fatura`}
                </span>
                <span className="k">Tahsilat</span>
                <span className="v">{fmtMoney(v.collectionAmount)} ₺</span>
                {(v.balanceBefore != null || v.balanceAfter != null) && (<>
                  <span className="k">Cari bakiye</span>
                  <span className="v">{fmtMoney(v.balanceBefore)} ₺ → {fmtMoney(v.balanceAfter)} ₺</span>
                </>)}
                {v.isDeleted && (<>
                  <span className="k">Silinme</span>
                  <span className="v"><span className="pill r">Silinmiş</span> {v.deleteReason}</span>
                </>)}
              </div>

              <div className="dsec">GPS — Giriş / Çıkış</div>
              <MiniMap v={v} />
              <div className="kv" style={{ marginTop: 10 }}>
                <span className="k">Noktaya uzaklık</span>
                <span className="v">
                  {v.gpsDistanceMeters != null
                    ? <>{v.gpsDistanceMeters} m {v.gpsWithinDistance === false && <span className="pill r">Aşım</span>}</>
                    : 'ölçülemedi'}
                </span>
                <span className="k">Hassasiyet</span>
                <span className="v">{v.gpsAccuracyMeters != null ? `${v.gpsAccuracyMeters} m` : '—'}</span>
              </div>

              <div className="dsec">Hareket Akışı ({activities.length})</div>
              {activities.length === 0 && (
                <div style={{ padding: '10px 0', color: 'var(--t3)', fontSize: 12 }}>
                  Bu ziyaret için hareket kaydı yok.
                </div>
              )}
              {activities.map((a) => (
                <div className="arow" key={a.id} style={{ paddingLeft: 0 }}>
                  <span className="at">{fmtTime(a.occurredAt, true)}</span>
                  <span className={`dot a-${a.activityGroup || 'other'}`}>•</span>
                  <span className="nm">{a.name || a.activityType}</span>
                  <span className="meta">
                    {/* #777.4/#777.5 Akıştaki (FieldWatchTab) ile AYNI kural: link'in koşulu
                        gidilebilir kayıt, belge no değil.
                        #793 Türetilmiş satırlarda (ziyarete başla/bitir, GPS damgası) gidilecek bir
                        kayıt yoktur — sunucu `isSynthetic` ile işaretler. */}
                    {!a.isSynthetic && activityTarget(a)
                      ? (
                        <span className="docno" role="button" tabIndex={0}
                          title="Kaydı aç"
                          onClick={() => onOpenDocument(a)}
                          onKeyDown={(e) => e.key === 'Enter' && onOpenDocument(a)}>
                          {activityTargetLabel(a)}
                        </span>
                      )
                      : a.documentNo}
                    {a.skuCount > 0 && <> · {a.skuCount} çeşit</>}
                    {a.paymentType && <> · {PAYMENT_LABELS[a.paymentType] || a.paymentType}</>}
                  </span>
                  {a.amount != null && a.amount !== 0 && (
                    <span className="amt">{fmtMoney(a.amount)} ₺</span>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </aside>
    </>
  );
}

/**
 * Şematik mini harita: müşteri konumu, giriş ve çıkış pinleri.
 *
 * Gerçek harita (Leaflet) BİLEREK kullanılmadı — drawer içinde tek bir ziyaretin üç
 * noktasını göstermek için tile indirmek gereksiz. Koordinatlar üçünün bounding box'ına
 * göre normalize edilip yüzdeyle konumlanır; gün izi haritası ayrı bir ekrandır
 * (GET /api/visit-tracking/gps-track/{sessionId}).
 */
function MiniMap({ v }) {
  const pts = [
    { key: 'c', lat: num(v.customerLatitude), lng: num(v.customerLongitude), Icon: IcStore, title: 'Müşteri' },
    { key: 'i', lat: num(v.startLatitude), lng: num(v.startLongitude), Icon: IcLogin, title: 'Giriş' },
    { key: 'o', lat: num(v.endLatitude), lng: num(v.endLongitude), Icon: IcLogout, title: 'Çıkış' },
  ].filter((p) => p.lat != null && p.lng != null);

  if (pts.length === 0) {
    return <div className="vmap"><div className="nogps">Konum kaydı yok</div></div>;
  }

  const lats = pts.map((p) => p.lat);
  const lngs = pts.map((p) => p.lng);
  const minLat = Math.min(...lats); const maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs); const maxLng = Math.max(...lngs);
  // Tek nokta varsa (span 0) ortaya koy; aksi halde %20–%80 aralığına yay.
  const spanLat = maxLat - minLat || 1;
  const spanLng = maxLng - minLng || 1;
  const pos = (p) => ({
    left: `${20 + ((p.lng - minLng) / spanLng) * 60}%`,
    top: `${80 - ((p.lat - minLat) / spanLat) * 60}%`,
  });

  return (
    <div className="vmap">
      {pts.map((p) => {
        const { Icon } = p;
        return (
          <div key={p.key} className={`pin ${p.key}`} style={pos(p)} title={p.title}>
            <Icon size={13} />
          </div>
        );
      })}
    </div>
  );
}

function num(x) {
  if (x === null || x === undefined) return null;
  const n = Number(x);
  return Number.isFinite(n) && n !== 0 ? n : null;
}
